import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomAlertComponent } from './custom-alert/custom-alert.component';
import { LoaderSpinerComponent } from './loader-spiner/loader-spiner.component';
import { BoxLoaderComponent } from './box-loader/box-loader.component';
import { TablaBusquedaComponent } from './tabla-busqueda/tabla-busqueda.component';
import { IssysLoaderComponent } from './issys-loader/issys-loader.component';
import { LoaderBloqueanteComponent } from './loader-bloqueante/loader-bloqueante.component';
import { SpinnerSimpleComponent } from './spinner-simple/spinner-simple.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { NgSelectModule } from '@ng-select/ng-select';




@NgModule({
  declarations: [
    CustomAlertComponent,
    LoaderSpinerComponent,
    BoxLoaderComponent,
    TablaBusquedaComponent,
    IssysLoaderComponent,
    LoaderBloqueanteComponent,
    SpinnerSimpleComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    NgbTooltipModule,
    FontAwesomeModule,
    NgSelectModule,
  ],
  exports: [
    CommonModule,
    CustomAlertComponent,
    LoaderSpinerComponent,
    BoxLoaderComponent,
    TablaBusquedaComponent,
    IssysLoaderComponent,
    LoaderBloqueanteComponent,
    SpinnerSimpleComponent,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    NgbTooltipModule,
    FontAwesomeModule,
    NgSelectModule,
  ],
})
export class CustomComponentsModule { 
  constructor(library: FaIconLibrary){
    library.addIconPacks(fas);
  }
}
